import { useTheme } from "@/utils/theme-context";

import { useLocation, useNavigate } from "react-router-dom";
import Button from "../UI/Button";
import ReactQuill from "react-quill"; // Импортируем компонент Quill
import "react-quill/dist/quill.snow.css";
import { useState } from "react";
import {
  deleteObject,
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getFirestore,
  updateDoc,
} from "firebase/firestore";
import { db } from "@/firebase/firebaseConfig";

const EditLesson = () => {
  const location = useLocation();
  const [video, setVideo] = useState(location.state.video || {});
  const { id, currentCollection } = location.state || {};
  const { theme } = useTheme();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [content, setContent] = useState(video.content || "");
  const [title, setTitle] = useState(video.title || "");
  const [newVideoFile, setNewVideoFile] = useState(null);
  const [vimeoUrl, setVimeoUrl] = useState(video.videoURL||  null);

  const createVideoAndUpdateLesson = async (videoData) => {
    try {
      const videoRef = await addDoc(collection(db, `${id}Videos`), {
        ...videoData,
        createdAt: new Date(),
      });

      const newVideo = { id: videoRef.id, ...videoData };

      const lessonDocRef = doc(db, currentCollection, id);
      const lessonDocSnapshot = await getDoc(lessonDocRef);

      if (!lessonDocSnapshot.exists()) {
        console.error("Lesson document not found!");
        return;
      }

      const lessonData = lessonDocSnapshot.data();
      const videos = lessonData.videos || [];

      videos.push(doc(db, `${id}Videos`, videoRef.id));

      try {
        await updateDoc(lessonDocRef, { videos });

        setVideo(newVideo);

        alert("Новый контент и реферанс добавлены!");
      } catch (error) {
        console.log(error);
      }
    } catch (error) {
      console.error(
        "Ошибка при добавлении контента и обновлении реферанса:",
        error
      );
      alert("Произошла ошибка!");
    }
  };

  const handleContentChange = (value) => {
    setContent(value);
  };

  const uploadFile = async (file) => {
    const storage = getStorage();
    const folder = `${id}Videos`;
    const fileRef = ref(storage, `${folder}/${file.name}`);
    const uploadTask = uploadBytesResumable(fileRef, file);

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        null,
        (error) => reject(error),
        async () => {
          const url = await getDownloadURL(fileRef);
          resolve(url);
        }
      );
    });
  };

  const uploadImagesFromQuill = async (quillContent) => {
    const div = document.createElement("div");
    div.innerHTML = quillContent;
    const images = div.querySelectorAll("img");

    for (const img of images) {
      if (img.src.startsWith("data:image")) {
        // Преобразуем Base64 изображение в Blob
        const blob = await fetch(img.src).then((res) => res.blob());
        const file = new File([blob], `image_${Date.now()}.png`, {
          type: blob.type,
        });

        const imgURL = await uploadFile(file);

        img.src = imgURL;
      }
    }

    return div.innerHTML;
  };

  const handleSave = async () => {
    setLoading(true);

    let url = video.url || null;

    try {
      const updatedContent = await uploadImagesFromQuill(content, id);

      // 🔵 Загружаем новое видео (если изменилось)
      if (newVideoFile) {
        // Проверка на правильный файл
        if (newVideoFile.type.startsWith("video/")) {
          try {
            url = await uploadFile(newVideoFile);
          } catch (error) {
            alert("Ошибка при загрузке видео:", error);
            return; // Прерываем выполнение, если загрузка видео не удалась
          }
        } else {
          alert("Выбранный файл не является видео.");
          return; // Если выбран не видеофайл, прекращаем выполнение
        }
      }

      let imagesToDelete = [];
      let imageURLsInContent = [];

      if (content) {
        imagesToDelete = video.content?.match(/src="(.*?)"/g) || [];
        imageURLsInContent = updatedContent?.match(/src="(.*?)"/g) || [];
      }

      if (imagesToDelete.length > 0) {
        const imagesToDeleteURLs = imagesToDelete.map((match) =>
          match.replace(/src="(.*?)"/, "$1")
        );

        const deletePromises = imagesToDeleteURLs.map(async (oldURL) => {
          if (!imageURLsInContent.includes(`src="${oldURL}"`)) {
            try {
              const storage = getStorage();
              const imageRef = ref(storage, oldURL);
              await deleteObject(imageRef);
              console.log("Изображение удалено из Storage");
            } catch (error) {
              console.error("Ошибка при удалении изображения:", error);
            }
          }
        });

        await Promise.all(deletePromises);
      }

      const videoData = {
        title: title,
        content: content,
        url: url,
        videoURL: vimeoUrl,
      };

      const db = getFirestore();

      const updateData = {
        title: title,
        content: updatedContent,
        videoURL: vimeoUrl,
      };

      if (url) {
        updateData.url = url;
      }

      if (video.id) {
        const docRef = doc(db, `${id}Videos`, video.id);
        await updateDoc(docRef, updateData);
      } else {
        await createVideoAndUpdateLesson(videoData);
        alert("Новый контент добавлен!");
      }

      setVideo((prev) => ({ ...prev, ...videoData }));

      alert("Данные успешно сохранены!");
    } catch (error) {
      console.error("Ошибка при сохранении:", error);
      alert("Произошла ошибка при сохранении!");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteVideo = async (url) => {
    if (!video.id) {
      alert("Нет видео для удаления!");
      return;
    }

    const confirmDelete = window.confirm(
      "Вы уверены, что хотите удалить это видео?"
    );
    if (!confirmDelete) {
      return;
    }

    setLoading(true);
    const storage = getStorage();
    const videoRef = ref(storage, url);

    try {
      // Delete video from Storage
      await deleteObject(videoRef);
      console.log("Видео удалено из Storage");

      // Update Firestore to remove the video URL
      const db = getFirestore();
      const docRef = doc(db, `${id}Videos`, video.id);
      await updateDoc(docRef, { url: "" });

      alert("Видео удалено из базы");

      setVideo((prevState) => ({ ...prevState, url: null }));
    } catch (error) {
      console.error("Ошибка при удалении видео:", error);
      alert("Произошла ошибка при удалении видео!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="layout layout--admin">
      <div className="accountInfo-body-item">
        <label htmlFor="title">Название</label>
        <input
          required
          name="title"
          defaultValue={video.title}
          type="text"
          className={`input input--${theme}`}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <div className="accountInfo-body-item">
        <label htmlFor="vimeoUrl">Ссылка на Vimeo (Вставьте только ID) </label>
        <input  onChange={(e) =>setVimeoUrl(e.target.value) } name='vimeoUrl' defaultValue={video.videoURL} type='text'  className={`input input--${theme}`} />
      </div>

      <div className="accountInfo-body-item">
        <label htmlFor="content">Контент</label>
        <ReactQuill
          value={content}
          onChange={handleContentChange}
          theme="snow"
          modules={{
            toolbar: [
              [{ header: "1" }, { header: "2" }],
              [{ list: "ordered" }, { list: "bullet" }],
              ["bold", "italic", "underline"],
              [{ align: [] }],
              ["link", "image"],
              ["clean"],
            ],
          }}
          style={{ height: "400px", paddingBottom: "50px" }}
          className={`input input--${theme}`}
        />
      </div>

      <div className="accountInfo-body-item">
        <label htmlFor="title">Видео</label>
        <video key={video.url} width={400} src={video.url}></video>
        <input
          type="file"
          accept="video/*"
          onChange={(e) => setNewVideoFile(e.target.files[0])}
        />
      </div>

      <div className="edit-lesson-buttons">
        {loading ? (
          <Button color="black" title="Секунду" disabled></Button>
        ) : (
          <Button title="Сохранить" color="blue" onClick={handleSave}></Button>
        )}

        {loading ? (
          <Button color="black" title="Секунду" disabled></Button>
        ) : (
          <Button
            title="Удалить видео"
            color="red"
            onClick={() => handleDeleteVideo(video.url)}
          ></Button>
        )}
        <Button
          title="Вернуться к модулю"
          color="blue"
          onClick={() => navigate(-1)}
        ></Button>
      </div>
    </div>
  );
};

export default EditLesson;
